const linkOrVoid = (link, isMailTo = false) =>
  (link ? `${isMailTo ? 'mailto:' : ''}${link}` : 'javascript:void(0)');

export default linkOrVoid;
